export default "__VITE_ASSET__CMom3SUI__"